import styled from 'styled-components';

import Nullable from 'packages/kakapo-ui-services/types/Nullable';

interface IProps {
	error: Nullable<Error>;
}

const Element = styled.p`
	color: ${(props) => props.theme.colors.danger};
	padding-top: 6px;
`;

export default function FormErrorMessage(props: IProps) {
	const { error } = props;

	return <Element>{error?.message}</Element>;
}
